import { AttachmentsTypes } from './actionTypes';

const INIT_STATE = {
  attachmentList: [],
  attachmentData: {},
  error: '',
  success: '',
  isLoading: false,
  isLoadingBase64: false,
};

const Attachments = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case AttachmentsTypes.GET_ATTACHMENTS:
      return {
        ...state,
        attachmentData: {},
        isLoading: true,
      };
    case AttachmentsTypes.GET_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        attachmentList: action.payload,
        isLoading: false,
      };
    case AttachmentsTypes.GET_ATTACHMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        attachmentList: [],
        isLoading: false,
      };
    case AttachmentsTypes.GET_ONE_ATTACHMENT:
      return {
        ...state,
        isLoadingBase64: true,
      };
    case AttachmentsTypes.GET_ONE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachmentData: action.payload,
        isLoadingBase64: false,
      };
    case AttachmentsTypes.GET_ONE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        attachmentData: {},
        isLoadingBase64: false,
      };
    default:
      break;
  }
  return state;
};

export default Attachments;
